import React from 'react';
import { Stack } from 'react-bootstrap';
import { BsClock } from 'react-icons/bs';
import { ReactComponent as ChefHat } from '../../../assets/icons/chef-hat.svg';
import { Course } from '../../../types/course.type';
import { DateCell } from '../../../components/tables/cellComponents/DateCell';
import { getCourseSessionTimeDisplay } from '../../../utils/dateUtils';

export const StylePink: React.CSSProperties = {
  fill: `#BA1F69`
};

export const StyleOrange: React.CSSProperties = {
  fill: `#d36a48`
};

export const StyleGreen: React.CSSProperties = {
  fill: `#B4C634`
};

export const course_type_style_lookup = (key: string) => {
  switch (key) {
    case 'after_school':
      return StylePink;
    case 'camp':
      return StyleOrange;
    case 'event':
      return StyleGreen;
    default:
      return {};
  }
};

interface CourseTimesProps {
  course: Course;
  dayOfWeek?: string;
}

export const CourseTimes: React.FC<CourseTimesProps> = ({ course, dayOfWeek }) => {
  const timeDisplay = getCourseSessionTimeDisplay(course);

  return (
    <Stack gap={1}>
      {dayOfWeek && <span>{dayOfWeek}</span>}
      {timeDisplay && (
        <div className="d-flex align-items-center gap-1">
          <BsClock className="flex-shrink-0" />
          <span>{timeDisplay}</span>
        </div>
      )}
    </Stack>
  );
};

interface CourseClassCountProps {
  course: Course;
}

export const CourseClassCount: React.FC<CourseClassCountProps> = ({ course }) => {
  const chefHatStyle = {
    transform: 'translateY(-2px)',
    ...course_type_style_lookup(course.course_type)
  };

  return (
    <div
      className="d-flex align-items-center gap-1 text-muted flex-shrink-0"
      style={{ fontSize: '0.875rem' }}
    >
      <ChefHat style={chefHatStyle} className="flex-shrink-0" />
      <span className="text-nowrap">
        {course.lessons.length} {course.lessons.length === 1 ? 'Class' : 'Classes'}
      </span>
    </div>
  );
};

interface CourseClassCountAndFormatProps {
  course: Course;
}

export const CourseClassCountAndFormat: React.FC<CourseClassCountAndFormatProps> = ({ course }) => {
  return (
    <div className="d-flex align-items-center flex-wrap">
      <CourseClassCount course={course} />
      <span className="text-muted">&nbsp;|&nbsp;</span>
      <b className="text-muted">{course.is_online ? 'Online' : 'In-Person'}</b>
    </div>
  );
};

interface CourseDateTimesProps {
  course: Course;
}

export const CourseDateTimes: React.FC<CourseDateTimesProps> = ({ course }) => {
  return (
    <Stack gap={1}>
      <span className="text-truncate">
        <DateCell date={course.starts_on} format="MM/dd/yyyy" />
        {' - '}
        <DateCell date={course.ends_on} format="MM/dd/yyyy" />
      </span>
      <CourseTimes
        course={course}
        dayOfWeek={course.day_of_week}
      />
    </Stack>
  );
};
